export const billingMutationKeys = {
  createPurchaseOrder: ['createPurchaseOrder'],
  createOrderIntent: ['createOrderIntent'],
  confirmOrderIntent: ['confirmOrderIntent'],
  createPurchaseOrderSaga: ['createPurchaseOrderSaga'],
  createPurchaseOrderCat: ['createPurchaseOrderCat'],
  createCmediaPurchase: ['createCmediaPurchase']
};
